export enum Network {
	Ethereum = 'ethereum',
	Polygon = 'polygon',
	Arbitrum = 'arbitrum',
	BinanceSmartChain = 'binancesmartchain',
	Avalanche = 'avalanche',
	Fantom = 'fantom',
	xDai = 'xdai',
}
